<template>
    <div class="contractManagement">
        <div class="condition">
            <div class="item">
                <div class="label">综合查询:</div>
                <el-input v-model="conditionData.Keyword" size="small" placeholder="综合查询" style="width:200px"></el-input>
            </div>

            <!-- <div class="item">
                <div class="label">甲方分公司/机构:</div>
                <el-input v-model="conditionData.JfCompnayName" size="small" placeholder="甲方分公司/机构" style="width:200px"></el-input>
            </div>
            <div class="item">
                <div class="label">乙方分公司/机构:</div>
                <el-input v-model="conditionData.yfCompnayName" size="small" placeholder="乙方分公司/机构" style="width:200px"></el-input>
            </div> -->
            <div class="item">
                <div class="label">合同时间:</div>
                <el-date-picker
                v-model="contractDate"
                type="daterange"
                size="small"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
                </el-date-picker>
            </div>

            <!-- <div class="item">
                <div class="label">合同状态:</div>
                <el-select v-model="conditionData.status" size="small" style="width:200px" placeholder="请选择">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div> -->

            <div class="item">
                <div class="label">涉及事业部:</div>
                <el-input v-model="businessName" size="small" placeholder="涉及事业部" style="width:200px"></el-input>
                <el-button size="small" type="primary" @click="isSelectBusiness = true">选择</el-button>
            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div class="table-btns">
                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="showAddDialog">新建</el-button>
                    <!-- <el-button type="success" icon="el-icon-download" size="small" @click="downloadExcel()">下载导入模板</el-button> -->
                    <el-button type="success" icon="el-icon-download" size="small" @click="exportExcel" plain style="margin-right:10px">导出excel</el-button>
                    <!-- <el-upload
                        :action="uploadUrl"
                        Multiple
                        :show-file-list="false"
                        :http-request="importExcel"
                        >
                        <el-button type="primary" icon="el-icon-upload" size="small" plain>导入excel</el-button>
                    </el-upload> -->

                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="buChongXinxi"
                label="合同编号"
                align="center"
                width="200"
                :show-overflow-tooltip="true"
                >
                </el-table-column>
                <!-- <el-table-column
                prop="code"
                label="状态"
                align="center"
                width="100"
                >
                </el-table-column> -->
                <!-- <el-table-column
                prop="code"
                label="添加时间"
                align="center"
                width="100"
                >
                </el-table-column> -->
                <el-table-column
                prop="contractStartDate"
                label="合同时间起"
                align="center"
                :show-overflow-tooltip="true"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="contractEndDate"
                label="合同时间止"
                align="center"
                :show-overflow-tooltip="true"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="contractName"
                label="合同名称"
                align="center"
                :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                prop="businessNames"
                label="涉及事业部"
                align="center"
                :show-overflow-tooltip="true"
                >
                <!-- <template slot-scope="scope">
                    <span class="" v-for="(item,index) in scope.row.businessResponses" :key="index">
                        {{index==0?item.name:','+item.name}}
                    </span>
                </template> -->
                </el-table-column>
                
                <el-table-column
                prop="jfCompnayName"
                label="甲方"
                align="center"
                :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                prop="yfCompnayName"
                label="乙方"
                align="center"
                :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                prop=""
                label="审核状态"
                align="center"
                :show-overflow-tooltip="true"
                v-if="isAudit"
                width="120"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="audit(scope.row)" v-if="scope.row.auditStatus==1">审核</el-button>
                    <el-button type="text" icon="el-icon-edit" size="mini" v-if="scope.row.auditStatus==2" disabled>审核通过</el-button>
                    <el-button type="text" icon="el-icon-edit" size="mini" v-if="scope.row.auditStatus==-1" disabled>审核未通过</el-button>
                </template>
                </el-table-column>


                <el-table-column
                fixed="right"
                label="操作"
                width="150px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="isUpdateDialogShow(scope.row)">编辑</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteTip(scope.row)">删除</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>


        
        <el-dialog :visible.sync="isSelectBusiness" title="选择事业部" width="960px">
            <div class="condition">
                <div class="item" style="border:0">
                    <div class="label">分公司/机构名称:</div>
                    <el-input v-model="businessConditionData.Name" size="small" placeholder="请输入" style="width:300px"></el-input>
                </div>
            
                <div class="btns">
                    <el-button type="primary" size="small" @click="selectBusinessData()">查询</el-button>
                    <el-button type="" size="small" @click="resetBusiness()">重置</el-button>
                </div>
            </div>

            <el-table
                :data="businessList"
                style="width: 100%">
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="code"
                label="事业部编号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="事业部名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="contacts"
                label="事业部联系人"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="contactsPhone"
                label="联系人电话"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="businessPerson"
                label="事业部负责人"
                align="center"
                >
                </el-table-column>
                
                <el-table-column
                fixed="right"
                label="操作"
                width="100px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="primary" icon="el-icon-circle-check" size="mini" @click="affirmBusiness(scope.row)">选择</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleBusinessCurrentChange"
                    background
                    layout="prev, pager, next"
                    :total="businessTotalCount"
                    :current-page="businessConditionData.page"
                    :page-size="businessConditionData.pageSize">
                </el-pagination>
            </div>
        </el-dialog>
       
    </div>
</template>
<script>
import api from '../../../api/main'
import {parseTimeD} from '../../../utils/index'
import store from '../../../store';
export default {
    name: 'contractManagement',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            contractDate:[],
            businessList:[],
            isSelectBusiness:false,
            businessTotalCount:0,
            businessConditionData:{
                Name:'',
                page:1,
                pageSize:10,
            },
            
            businessName:'',
            title:'',
            isShow:false,
            isAddDialog:false,
            isUpdateDialog:false,
            totalCount:0,
            conditionData:{
                Keyword:'',
                BusinessIds:'',
                ContractStartDate:'',
                ContractEndDate:'',
                page:1,
                pageSize:10,
            },
            addData:{},
            updateData:{},
            tableData:[],
            uploadUrl:'',
            isAudit:false,
        }
    },
    created(){
        

    },
    mounted(){
        console.log('global/s_btnsList');
        console.log(store.getters['global/s_btnsList']);
        let btnsList = store.getters['global/s_btnsList'];
        for(let index in btnsList){
            if(btnsList[index].name=='审核'&&btnsList[index].isCheck){
                this.isAudit = true;
            }
        }
        this.loadingData();
        this.getBusiness();
    },
    methods:{
        // async querySearch(queryString, cb){
        //     let list = this.list;
        //     console.log(queryString);
        //     let results = queryString ? list.filter(this.createFilter(queryString)) : list;
        //     console.log(results);
        //     cb(results);
        // },
        // handleSelect(e){
        //     console.log(e);
        //     this.conditionData.BusinessIds = e.name;
        // },
        // createFilter(queryString) {
        //     return (list) => {
        //         return (list.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        //     };
        // },

        // table样式
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        // 案件列表
        async loadingData() {
            if(this.contractDate.length>0){
                this.conditionData.ContractStartDate = parseTimeD(this.contractDate[0]);
                this.conditionData.ContractEndDate = parseTimeD(this.contractDate[1]);
            }else{
                this.conditionData.ContractStartDate = null;
                this.conditionData.ContractEndDate = null;
            }
            let res  = await api.queryContractPager(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        // 查询列表
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        // 充值案件列表
        reset(){
            this.contractDate = [];
            this.businessName = '';
            this.conditionData = {
                Keyword:'',
                BusinessIds:'',
                ContractStartDate:'',
                ContractEndDate:'',
                page:1,
                pageSize:10,
            },
            this.loadingData();
        },
        // 案件分页
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        // 跳转到添加页面
        showAddDialog(){
            this.$router.push({
                name:'contractManagementAdd'
            });
        },
        // 跳转到编辑页面
        isUpdateDialogShow(row){
            console.log(row);
            this.$router.push({
                name:'contractManagementEdit',
                query:{
                    id:row.id
                }
            });
        },
        // 提示是否删除合同
        deleteTip(row){
            console.log(row);
            this.$confirm('是否删除当前选定的合同?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteContract(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },
        // 删除合同
        async deleteContract(row){
            let res = await api.deleteContract(row.id);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }
            this.loadingData();
        },
        // 获取部门列表
        async getBusiness(){
            let res  = await api.QueryCauseList(this.businessConditionData);
            console.log(res);
            this.businessList = res.data.data.data;
            this.businessTotalCount = res.data.data.totalCount;
            this.$forceUpdate();
        },
        // 部门列表分页
        handleBusinessCurrentChange(page){
            this.businessConditionData.page = page;
            this.getBusiness();
        },
        // 确认选择部门
        affirmBusiness(row){
            console.log(row);
            this.businessName = row.name;
            this.conditionData.BusinessIds = row.id;
            this.isSelectBusiness = false;
        },

        // 导出列表
        async exportExcel(){
            let res = await api.export({
                type: 1,
                condition:JSON.stringify(this.conditionData)
            });
        },

        async importExcel(file){
            let res = await api.import(file.file,{
                type: 1
            });
        },

        downloadExcel(){
            this.$message({
                type: 'success',
                message: '正在下载，请稍等!'
            })
            const elt = document.createElement('a');
            elt.setAttribute('href', 'http://txggpic.oss-cn-shenzhen.aliyuncs.com/20210706/20210706104549GNs6Q');
            elt.setAttribute('download', '合同模板.xlsx');
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },
        // 审核
        audit(row){
            console.log(row);
            this.$router.push({
                name:'contractManagementAudit',
                query:{
                    id:row.id
                }
            });
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 5px;
        padding: 10px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            margin-right: 20px;
            padding: 5px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
            padding: 5px 0;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .table-btns{
            display: flex;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        .item{
            font-size: 14px;
            padding:10px 15px;
            .label{
                margin-bottom: 5px;
            }
        }
        
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
